import {avatarsClient} from 'common/report/queries/app-api/avatars-client';

import {Store} from './store';

interface AvatarResults {
  base: string;
  avatars: {[userId: number]: string};
}

export const avatarsStore = new Store<AvatarResults>({
  apiClient: avatarsClient,
  defaultValue: {},
  name: `avatars`,
});
